export default async function loadTranslations(locale: string) {
  try {
    const response = await fetch(`/i18n/${locale}.json`);
    if (!response.ok) return {};
    return await response.json();
  } catch (error) {
    console.warn(`No translations found for ${locale}`);
    return {};
  }
}
